import { useCallback } from 'react'
import type { ReactNode } from 'react'

import LoyaltySocietePointsFilterGroup from 'loyalty/components/LoyaltySocietePointsFilterGroup'
import useLoyaltyBurnExperiment from 'loyalty/hooks/useLoyaltyBurnExperiment'
import { deleteSearchParams, setSearchParamValue } from 'lib/url/searchUrlUtils'
import type { FilterControlChangeHandler } from './HotelSearchPageFilterPane'

interface Props {
  filters: App.OfferListFilters
  searchParams: string
  currentHash: string
  onFilterChange: FilterControlChangeHandler
  title?: ReactNode
  additionalFilters?: ReactNode
  loading?: boolean
}

function HotelSearchSocieteFilters({ filters, searchParams, currentHash, onFilterChange, title, additionalFilters, loading }: Props) {
  const { isAnyVariant: isBurnEnabled } = useLoyaltyBurnExperiment()
  const viewPriceInPoints = !!filters.viewPriceInPoints

  const handleViewPriceInPointsChange = useCallback((nextViewPriceInPoints: boolean) => {
    const newSearchParams = nextViewPriceInPoints
      ? setSearchParamValue(searchParams, 'viewPriceInPoints', 'true')
      : deleteSearchParams(searchParams, 'viewPriceInPoints')
    onFilterChange({ search: newSearchParams, hash: currentHash })
  }, [searchParams, currentHash, onFilterChange])

  if (!isBurnEnabled && !additionalFilters) {
    return null
  }

  return (
    <LoyaltySocietePointsFilterGroup
      skipBurnExperiment
      showPointsFilters={isBurnEnabled}
      viewPriceInPoints={viewPriceInPoints}
      onViewPriceInPointsChange={handleViewPriceInPointsChange}
      title={title}
      loading={loading}
      additionalFilters={additionalFilters}
    />
  )
}

export default HotelSearchSocieteFilters
